import { accountApi, clientRecords, extractError } from '@atheneum/api'
import { action, computed, extendObservable } from 'mobx'

class AccountStore {
  constructor(growlStore) {
    extendObservable(this, {
      id: null,
      account: null,
      parentAccount: null,
      loading: false,
      error: null,
      invoicingEntities: null,
      employees: null,
      contracts: null,
      projectCount: null,
      projectFeedback: null,
      projectFeedbackAvg: computed(() => {
        if (this.projectFeedback) {
          return this.projectFeedback.toFixed(2)
        } else {
          return 'N/A'
        }
      }),
      growlStore
    })
  }

  load(id) {
    this.id = Number(id)
    this.loading = true

    return accountApi.getAccount(id)
      .then(account => {
        this.account = account

        Promise.all([
          clientRecords.getParentAccount(this.account.parentAccountId),
          accountApi.getInvoicingEntities(id),
          accountApi.getContracts(id),
          accountApi.getProjectCount(id),
          accountApi.getFeedbacks(id)
        ]).then(
          ([
            parentAccount,
            invoicingEntities,
            contracts,
            projectCount,
            projectFeedback
          ]) => {
            this.parentAccount = parentAccount
            this.invoicingEntities = invoicingEntities
            this.contracts = contracts
            this.projectCount = projectCount
            this.projectFeedback = projectFeedback.ratingAvg

            this.loading = false
          }
        )
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  deleteAccount = action(accountId => {
    return accountApi.deleteAccount(accountId).catch(err => {
      this.error = extractError(err)
      this.growlStore.addNotification({
        title: 'Error!',
        message: this.error.message,
        type: 'error',
        autoClose: true
      })

      throw err
    })
  })
}

export default AccountStore
